// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "calendar-" + chunkId + ".js?v=" + {"node_modules_nextcloud_vue_dist_Components_NcColorPicker_mjs":"835bc3c3842b13472f91","node_modules_nextcloud_vue_dist_Components_NcSelect_mjs":"e85f9b8cc199a3ed2a0a","vendors-node_modules_rehype-highlight_index_js":"463c60d5922b76483543"}[chunkId] + "";
};